import PreAssessment from "@workspace/job/src/components/PreAssessment/PreAssessment";

export const moduleConstants = [
  { label: "Accounts", value: "Accounts" },
  { label: "Jobs", value: "Jobs" },
  { label: "Candidates", value: "Candidates" },
  { label: "User", value: "User" },
  // { label: "JobTimeline", value: "JobTimeline" },
  { label: "TOS", value: "TOS" },
];

export const USER_OPTIONS = {
  basicInfo: [
    { label: "First Name", value: "firstName" },
    { label: "Last Name", value: "lastName" },
    { label: "Email", value: "email" },
    { label: "Mobile Ext.", value: "mobileExt" },
    { label: "Mobile No.", value: "mobile" },
    { label: "Employee Id", value: "employeeId" },
    { label: "Designation", value: "designation" },
    { label: "Location", value: "location" },
    { label: "Department", value: "department" },
    { label: "Office Ext.", value: "officeExt" },
    { label: "Office No.", value: "officeNo" },
  ],
};

export const JOBTIMELINE_OPTIONS = {
  tosForm: [],
  tosRejection: [],
};

export const injectionVariables = [
  { label: "Reset Password Link", value: "RESET_PASSWORD_LINK" },
  { label: "Login OTP Token", value: "LOGIN_OTP_TOKEN" },
];

export const fixedVariables = {
  Login: [
    { label: "Login OTP Token", value: "LOGIN_OTP_TOKEN", type: 1 },
    { label: "Reset Password Link", value: "RESET_PASSWORD_LINK", type: 1 },
  ],
  PreAssessment: [
    { label: "Pre-Assessment Link", value: "PRE_ASSESSMENT_LINK", type: 2 },
    {
      label: "Pre-Assessment Recruiter Name",
      value: "PRE_ASSESSMENT_RECRUITER_NAME",
      type: 2,
    },
    {
      label: "Pre-Assessment Recruiter Email",
      value: "PRE_ASSESSMENT_RECRUITER_EMAIL",
      type: 2,
    },
  ],
  Interview: [
    { label: "Interview Start Date", value: "INTERVIEW_START_DATE", type: 2 },
    { label: "Interview End Date", value: "INTERVIEW_END_DATE", type: 2 },
    { label: "Interview Start Time", value: "INTERVIEW_START_TIME", type: 2 },
    { label: "Interview End Time", value: "INTERVIEW_END_TIME", type: 2 },
    { label: "Interview Location", value: "INTERVIEW_LOCATION", type: 2 },
  ],
  TOS: [
    { label: "TOS Submitted Link", value: "TOS_SUBMITTED_LINK", type: 1 },
    { label: "TOS Rejected Reason", value: "TOS_REJECTED_REASON", type: 1 },
  ],
};
